export { default as SellerGdmRegisterPage } from './pages/SellerGdmRegisterPage';
export { default as SellerGdmEditPage } from './pages/SellerGdmEditPage';
export { default as SellerGdmViewPage } from './pages/SellerGdmViewPage';
